import React from 'react';

import { EHashLinks } from '@enum';

import { ProfileCard } from '@components/ProfileCard';
import { SectionWrapper } from '@components/SectionWrapper';
import { DoubleColorBackground } from '@components/DoubleColorBackground';

export const Profile = () => (
  <SectionWrapper
    sectionId={EHashLinks.profile}
    background={<DoubleColorBackground />}
  >
    <ProfileCard />
  </SectionWrapper>
);
